<template>
  <div id="audio">
    <!--↓audioタグ使用-->
    <!--<figure>-->
    <!--  <audio controls v-bind:src="src">-->
    <!--          Your browser does not support the-->
    <!--          <code>audio</code> element.-->
    <!--  </audio>-->
    <!--</figure><br><br>-->

    <GreenAudioPlayer v-if="isAudio" :contentUrl="src" ref="GreenAudioPlayer" class="greenAudioPlayer"/><br>
    
    <GreenVideoPlayer v-if="isVideo" :contentUrl="src" ref="GreenVideoPlayer" class="greenVideoPlayer"/><br>
    
    <div class="error_message" v-if="isError" v-html="errorMessage"></div>
    
    <!--<div id="modal">-->
    <!--  <el-dialog v-if="!user" :visible.sync="dialogVisible" width="80%" top="10%" :before-close="handleClose" :show-close="false" :close-on-click-modal="false">-->
    <!--    <p font-size="0.5em">このコンテンツの視聴には<br>サインインが必要です</p>-->
    <!--    <el-button type="warning" v-if="!user" v-on:click="openSubWindow" size="mini">サインイン</el-button>-->
    <!--  </el-dialog>-->
    <!--</div>-->
    
    <!--<el-button type="warning" v-if="user" v-on:click="signOut" size="mini">サインアウト(開発用)</el-button>-->
    
  </div>
</template>

<script>
  import { Auth, Storage } from 'aws-amplify';
  import store from '@/store/index.js';
  import GreenAudioPlayer from '@/components/AmpluggedPlayer/GreenAudioPlayer';
  import GreenVideoPlayer from '@/components/AmpluggedPlayer/GreenVideoPlayer';
  Storage.configure({
    customPrefix: {
      public: 'samplePrefix/'
    },
    // ...
  })

  // new GreenAudioPlayer('.gap-example');

  export default {
    name: 'AmpluggedPlayer',
    data() {
      return {
        //CloudFrontのURLを使う場合はコメントアウト外す
        audioSrc: 'https://stg.internal.amplugged.com/nnctest/audio/sword-slash1.mp3',
        // src: 'https://stg.internal.amplugged.com/nnctest/video/Middle/inov_01.mp4',
        videoSrc: 'https://dev.internal.amplugged.com/nnctest/video/Middle/inov_03/inov_03.m3u8',
        'currentEnv': process.env.VUE_APP_VUE_ENV,
        src: '',
        isAudio: false,
        isVideo: false,
        isError: false,
        errorMessage: '',
        dialogVisible: false,
        fileUrl: this.contentUrl
      }
    },
    components: {
      GreenAudioPlayer,
      GreenVideoPlayer
    },
    props: {
      contentUrl: String
    },
    computed: {
      user() {
        return store.state.user;
      }
    },
    beforeCreate: async function() {
      function checkRefferer() {
        const referrer = document.referrer;
        // console.log(`リファラー${referrer}`);
        const google = 'https://accounts.google.com/';
        const cognito = 'https://empb69ce251-b69ce251-dev.auth.ap-northeast-1.amazoncognito.com/'
        if (referrer === google ||
          referrer === cognito) {
          window.opener.location.reload();
          window.close();
        }
      }

      await checkRefferer();
    },
    created: function() {
    },
    mounted: async function() {
      // const s3key = 'sword-slash1.mp3'
      // await Storage.get(s3key)
      //   // .then(result => { 
      //   .then(function(result) {
      //     // console.log(result);
      //     this.src = result
      //   })
      //   .catch(function(err) {console.log(err)});
      if (!this.user) {
        this.dialogVisible = true;
      }

      const file = process.env.VUE_APP_FILE_URL+this.$route.path;
      fetch(file, {
        methods: "GET"
      })
      .then(res => {
        if(res.ok) {
          this.judgeFileType(file);
          this.src = file;
        } else {
          this.isError = true;
          this.errorMessage = 'ファイルが存在しません。<br>URLを確認して再度アクセスしてください。'
        }
      })
      .catch(err => {
        console.log(err);
      });
    },
    methods: {
      /**
       *サイイン用のサブウィンドウを表示する
       */
      openSubWindow: function() {
        // this.$router.push({ name: 'signin' });
        let routeData = this.$router.resolve({ name: 'signin' });
        // const hostedUI = "https://empb69ce251-b69ce251-dev.auth.ap-northeast-1.amazoncognito.com/login?client_id=7i4buu9o81hilvra9ea4lhjlqk&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https://503bbb8438ca4187bfcf87038d497c35.vfs.cloud9.ap-northeast-1.amazonaws.com/"
        window.open(routeData.href, 'サブウィンドウ', 'width=400, height=600');
        // window.open(hostedUI, 'サブウィンドウ', 'width=400, height=550');

      },
      /**
       *サインアウトする 
       */
      signOut: async function() {
        await Auth.signOut();
        await this.$store.commit('setUser', null);
      },
      judgeFileType: function(filePath) {
        const fileName = filePath.split("/").pop()
        const extension = fileName.split(".").pop();
        const audioExtensionList = ['mp3','aac','wav','ogg','mid','midi','ra'];
        const videoExtensionList = ['mp4', 'm3u8'];
        
        if(audioExtensionList.includes(extension)) {
          this.isAudio = true;
        } else if(videoExtensionList.includes(extension)) {
          this.isVideo = true;
        } else {
          this.isError = true;
          this.errorMessage = `URLが間違っています。<br>
                              埋め込みプレーヤーとして使用できるファイルの拡張子は以下の通りです。<br>
                              音声:<span class="bold">${audioExtensionList}</span><br>
                              動画:<span class="bold">${videoExtensionList}</span><br>`;
        }
      }
    }
  }
</script>

<style>
  /*@import "/nampla-ep/node_modules/green-audio-player/dist/css/green-audio-player.min.css";*/

  figure {
    margin: 0;
  }

  #modal {
    background-color: transparent;
  }

  .greenAudioPlayer,
  .greenAudioPlayer {
    margin-left: auto;
    margin-right: auto;
  }
  
  .error_message  {
    margin-bottom: 32px;
  }
  
  .bold {
    font-weight: bold;
  }
</style>
